export default (params) => ({
  trigger: {
    name: 'service_selector.click_confirm_button',
    params: params,
  },
  config: {
    schema: {
      status: {
        enum: [
          'success',
          'failure',
        ],
      },
    },
    event: {
      name: 'confirm',
      params: {
        sub_feature: 'measurement_overlay',
      },
    },
  },
});
